import { GroupDelegate, ItemDelegate, RelationshipBreadcrumbs } from '@leverege/molten/imagine'
import { LinkAction } from '@leverege/molten/routes'
import { GroupScreen, ItemInfoScreen } from '@leverege/molten/screens'
import { ValuesCache } from '@leverege/value-cache'
import React from 'react'

const actionsCache = new ValuesCache()

export default {
  create(
    molten,
    {
      id,
      layoutName,
      linkName,
      relationship,
      client = 'ItemScreen',
      icon,
      isPreferredRoute = false,
      layout,
      matches : pMatches,
      linkPath,
      isItem,
      embed,
      customQuery
    },
  ) {
    const { attribute, parentRelationship : pRel } = relationship
    const matches =
      attribute == null ?
        { client } :
        { client, path : embed ? relationship.path : pRel.path, objectType : embed ? relationship.blueprint.type : attribute.blueprint.type }
    const path =
      linkPath || relationship.urlPath.replace( /\/[^/]*$/, `/${layoutName}` )

    molten.addPlugin( 'Route', {
      id : `${id}.Route:breadcrumbs`,
      matches : { client : 'Breadcrumbs', },
      exact : true,
      path,
      render : ( { match, ...rest } ) => {
        const rel = isItem ?
          relationship.createItem( match ) :
          relationship.createResolved( match )?.parent
          
        return React.createElement(
          RelationshipBreadcrumbs,
          {
            match,
            ...rest,
            relationship : rel,
            extraCrumbs : [ {
              name : layoutName,
              url : path,
              relationship : rel
            } ]
          }
        )
      }
    } )

    molten.addPlugin( 'Route', {
      id : `${id}.Route`,
      matches,
      exact : true,
      path,
      default : isPreferredRoute,
      render : ( { match, ...rest } ) => {
        const rel = isItem ?
          relationship.createItem( match ) :
          relationship.createResolved( match )

        let delegate

        if ( actionsCache.isSame( rel.path, match.url ) ) {
          delegate = actionsCache.value( rel.path )
        } else {
          delegate = actionsCache.set(
            rel.path,
            isItem ?
              new ItemDelegate( { match, relationship : rel, queryName : `${relationship.path}.search` } ) :
              new GroupDelegate( { match, relationship : rel, queryName : `${relationship.path}.search` } ),
            match.url,
          )
        }

        const props = {
          match,
          ...rest,
          relationship : rel,
          resourceId : rel.id,

          delegate,
          actions : delegate,
          title : layoutName,
          icon,
          embed
        }
        return React.createElement( isItem ? ItemInfoScreen : GroupScreen, props )
      },
    } )

    molten.addPlugin(
      'Action',
      LinkAction.create( {
        id : `${id}.Link`,
        matches : pMatches || { use : 'navBar', client, path : pRel == null ? null : pRel.path },
        layout,
        handles : () => true,
        name : linkName || layoutName,
        icon,
        path,
        matchQuery : true,
        query : {
          v : `${customQuery || 's'}:${layoutName.replace( /\s/g, '' )}`,
        },
      } ),
    )
  },
}
